import { TreeAdapter, TreeAdapterParams, TreeOptions, TreeSource } from "@omegagrid/tree";
import { ModuleDefinition } from "@reporting/rp-types/definition";

export class ScenarioTreeAdapter extends TreeAdapter {

	public accounting: number;
	public years: number[] = [];

	constructor(
		private module: ModuleDefinition,
		private options?: Partial<TreeOptions>
	) { super() }

	async getTree(params: TreeAdapterParams): Promise<TreeSource> {
		return this.module.scenarios?.map(s => ({
			k: s.a_b,
			v: s.a_b,
		})) ?? [];
	}

	getOptions(): Partial<TreeOptions> {
		return this.options || {};
	}

}
